import * as React from 'react';
import cn from 'classnames';

import { OrderAdditionalServiceGdsServiceServiceType } from '@websky/graphql';
import { AvailableSegmentPassenger } from '../../../VipServiceSelect';
import { ThemeProvider, useTheme } from '../../../theme';
import { Money } from '../../../Money';
import { Money as MoneyType } from '../../../Money/types';
import Control, { Props as ControlProps } from '../../../VipServiceSelect/components/Control/Control';

export type Props = Pick<ControlProps, 'type' | 'count'> & {
	price: MoneyType;
	passenger: AvailableSegmentPassenger;
	serviceType?: OrderAdditionalServiceGdsServiceServiceType;
	isConfirmed: boolean;
	onSetCount: (passenger: AvailableSegmentPassenger) => (count: number) => void;
};

// TODO: перенести привязку класса passenger_vipService
/**
 * @deprecated use the showControlPrice prop instead of this component
 */
const PassengerPriceControl: React.FC<Props> = ({
	price,
	passenger,
	serviceType,
	isConfirmed,
	onSetCount,
	...props
}) => {
	const { Control: theme } = useTheme('CheckoutAdditionalService');

	return (
		<ThemeProvider
			value={{
				VipServiceSelect: {
					VipServiceSelect: {
						control: theme.control,
						control_counter: theme.control_counter
					}
				}
			}}
		>
			<div
				className={cn(theme.passenger, {
					[theme.passenger_vipService]: serviceType === OrderAdditionalServiceGdsServiceServiceType.Vip
				})}
			>
				<Control
					{...props}
					label={<div className={theme.label}>{passenger.name}</div>}
					disabled={isConfirmed}
					onSetCount={onSetCount(passenger)}
				/>

				{props.count > 0 && (
					<div className={theme.price}>
						<Money money={price} />
					</div>
				)}
			</div>
		</ThemeProvider>
	);
};

export default PassengerPriceControl;
